// extracted by mini-css-extract-plugin
export default {"wrap":"UF-z","fullWidth":"VF-z","hideOnDesktop":"WF-z","content":"XF-z","hasOpenedNav":"YF-z","crumbsList":"ZF-z","dropdownsWrap":"_F-z"};